import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(lang)/blogs/[id]/loading.jsx");
